module.exports = __webpack_public_path__ + "img/Azerbaijan.97282f1f.gif";